import { Orientation, type SerializedDockview } from 'dockview';
import type { TypedGroupviewPanelState } from '../../../../types/LayoutConfig';
import { BRANCH, LEAF } from '../../../Layout/tokens';

const PANELS: Record<string, TypedGroupviewPanelState> = {
  customerOrdersBlotter: {
    id: 'customerOrdersBlotter',
    contentComponent: 'customerOrdersBlotter',
    title: 'Customer Orders',
    params: { type: 'customerOrdersBlotter', tabs: undefined },
  },
  customerTradesBlotter: {
    id: 'customerTradesBlotter',
    contentComponent: 'customerTradesBlotter',
    title: 'Customer Trades',
    params: { type: 'customerTradesBlotter', tabs: undefined },
  },
  customerBalancesBlotter: {
    id: 'customerBalancesBlotter',
    contentComponent: 'customerBalancesBlotter',
    title: 'Customer Balances',
    params: { type: 'customerBalancesBlotter', tabs: undefined },
  },
};

const GRID: SerializedDockview['grid'] = {
  root: {
    type: BRANCH,
    data: [
      {
        type: LEAF,
        visible: true,
        data: {
          views: ['customerOrdersBlotter'],
          activeView: 'customerOrdersBlotter',
          id: 'customerOrdersBlotter',
        },
        size: 450,
      },
      {
        type: LEAF,
        visible: true,
        data: {
          views: ['customerTradesBlotter'],
          activeView: 'customerTradesBlotter',
          id: 'customerTradesBlotter',
        },
        size: 450,
      },
      {
        type: LEAF,
        visible: true,
        data: {
          views: ['customerBalancesBlotter'],
          activeView: 'customerBalancesBlotter',
          id: 'customerBalancesBlotter',
        },
        size: 450,
      },
    ],
    size: 1600,
  },
  width: 1600,
  height: 900,
  orientation: Orientation.HORIZONTAL,
};

export const CUSTOMER_ACTIVITY_LAYOUT: SerializedDockview = {
  grid: GRID,
  panels: PANELS,
};
